import { Table } from 'react-bootstrap';
import { SpaceWithOwner } from './GroupBookingsList';

/**
 * Passport Row
 */
export function PassportRow({ space }: { space: SpaceWithOwner }) {
  const guestName = space.guest.givenName
    ? `${space.guest.givenName} ${space.guest.familyName}`
    : undefined;
  const ownerName = `${space.owner.givenName} ${space.owner.familyName}`;

  const passport = space.guest.tripForm?.passportInformation;

  if (!passport) {
    return (
      <tr>
        <td>{guestName || <i>Booked by {ownerName}</i>}</td>
        <td colSpan={8} className="text-muted">
          <i>Not completed</i>
        </td>
      </tr>
    );
  }

  return (
    <tr>
      <td>{guestName || <i>Booked by {ownerName}</i>}</td>
      <td>{passport.givenName}</td>
      <td>{passport.familyName}</td>
      <td>{passport.nationality}</td>
      <td>{passport.passportNumber}</td>
      <td>{passport.issueDate}</td>
      <td>{passport.expiryDate}</td>
      <td>{passport.gender}</td>
      <td>{passport.dateOfBirth}</td>
    </tr>
  );
}

/**
 * Passport Table
 */
export default function PassportTable({
  spaces,
}: {
  spaces: SpaceWithOwner[];
}) {
  return (
    <Table striped bordered responsive>
      <thead>
        <tr>
          <th>Booking Name</th>
          <th>
            First Name
            <br />
            (as on passport)
          </th>
          <th>
            Last Name
            <br />
            (as on passport)
          </th>
          <th>Nationality</th>
          <th>Passport Number</th>
          <th>Issue Date</th>
          <th>Expiry Date</th>
          <th>Gender</th>
          <th>Date of Birth</th>
        </tr>
      </thead>
      <tbody>
        {spaces.map((space) => (
          <PassportRow space={space} key={space.id} />
        ))}
      </tbody>
    </Table>
  );
}
